import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../../../assets/scss/sections/_testimonials.scss';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const Testimonials = ({ setting_data, testimonial_data }) => {
  return (
    <>
      <section id="testimonials_wrapper">
        <Container className="testimonials_container">
          <h3 className="main_common_title text-center">
            <span className="common_span text-white">
              {setting_data?.home_page_testimonials_title}
            </span>
          </h3>
          <Row className="testimonial_row">
            <Col>
              <OwlCarousel
                className="owl-theme"
                loop
                margin={20}
                autoplay
                autoplayHoverPause
                dots={false}
                nav
                items={3}
                responsive={{
                  0: {
                    items: 1,
                  },
                  600: {
                    items: 1,
                  },
                  768: {
                    items: 2,
                  },
                  992: {
                    items: 3,
                  },
                }}>
                {testimonial_data.map((team) => (
                  <div className="item" key={team.testimonial_id.toString()}>
                    <div className="main_Card_wrapper">
                      <Card style={{ width: '100%' }}>
                        <Card.Img variant="top" src={team.image_url} />
                        <Card.Body>
                          <Card.Title className="card_title">{team.name}</Card.Title>
                          <Card.Title className="card_sub_title">{team.designation}</Card.Title>
                          <Card.Text className="card_contents">
                            {team?.description.replace(/<[^>]+>/g, '')}
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                ))}
              </OwlCarousel>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
Testimonials.propTypes = {
  setting_data: PropTypes.object,
  testimonial_data: PropTypes.array,
};
export { Testimonials };
